import React, { useCallback, useMemo, useState } from "react";

import FormDialog from "../../../../components/Dialog/FormDialog";
import TeamForm from "./TeamForm";

function Team({ params }) {
  const [openUpdateTeamDialog, setUpdateTeamDialog] = useState(false);

  const handleClose = useCallback((action) => {
    setUpdateTeamDialog(false);
  }, []);

  const handleClick = useCallback(() => {
    setUpdateTeamDialog(true);
  }, []);

  const teamNameDisplay = useMemo(() => {
    return params.value ? params.value.team_name : "NA";
  }, [params.value]);

  return (
    <>
      {openUpdateTeamDialog && (
        <FormDialog
          open={openUpdateTeamDialog}
          handleClose={handleClose}
          title={"Update Team"}
          btnTitle={"Update"}
          fullWidth={true}
        >
          <TeamForm params={params} onClose={handleClose} />
        </FormDialog>
      )}
      <div onClick={handleClick} className="cursor-pointer">
        <p className="underline">{teamNameDisplay}</p>
      </div>
    </>
  );
}

const isChangeTeam = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.team_id === nextProps?.params?.row?.team_id
    && prevProps?.params?.row?.team_name === nextProps?.params?.row?.team_name
    && prevProps?.params?.value === nextProps?.params?.value
    && prevProps?.params?.row?.first_name === nextProps?.params?.row?.first_name
    && prevProps?.params?.row?.last_name === nextProps?.params?.row?.last_name
  );
};

export default React.memo(Team, isChangeTeam);
